import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const WarningYellow: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--WarningYellow')}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path
          d="M12.8154246,3.66406486 L21.6328482,19.4091106 C21.8487304,19.794606 21.7112318,20.2821188 21.3257365,20.4980011 C21.2063114,20.5648806 21.0717238,20.6 20.9348471,20.6 L3.3,20.6 C2.8581722,20.6 2.5,20.2418278 2.5,19.8 C2.5,19.6631233 2.53511935,19.5285358 2.60199893,19.4091106 L11.4194225,3.66406486 C11.6353047,3.27856951 12.1228176,3.14107092 12.5083129,3.35695316 C12.6370451,3.4290448 12.743333,3.53533269 12.8154246,3.66406486 Z"
          fill="#FFE260"
          fillRule="nonzero"
        />
        <path
          d="M13,16.5 L13,18.5 L11,18.5 L11,16.5 L13,16.5 Z M13,9.5 L13,15.5 L11,15.5 L11,9.5 L13,9.5 Z"
          fill="#212222"
        />
      </g>
    </g>
  </svg>
);

export default WarningYellow;
